import { render, staticRenderFns } from "./r-item-recycle-config.vue?vue&type=template&id=2d1cbabe"
import script from "./r-item-recycle-config.vue?vue&type=script&lang=js"
export * from "./r-item-recycle-config.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d1cbabe')) {
      api.createRecord('2d1cbabe', component.options)
    } else {
      api.reload('2d1cbabe', component.options)
    }
    module.hot.accept("./r-item-recycle-config.vue?vue&type=template&id=2d1cbabe", function () {
      api.rerender('2d1cbabe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/item/recycle/r-item-recycle-config.vue"
export default component.exports